
export default {

  ADD_USER_LESSON_SCREENS (state, userLessonScreens) {
    state.userLessonScreens = [...state.userLessonScreens, ...userLessonScreens]
  },

  DELETE_USER_LESSON_SCREEN (state, uuid) {
    state.userLessonScreens = state.userLessonScreens.filter(x => x.uuid !== uuid)
  },

}
